export default __webpack_public_path__ + "static/media/kevin.104d8691.jpeg";